module.exports = __webpack_public_path__ + "img/hsevi.2e2f0547.png";